export class TilesClientLogger {
    info = (...any) => {
        console.log(...any);
    }
    error = (...any) => {
        console.log(...any);
    }
}
